export const sidebarItems = [
  {
    titleKey: "nav.dashboard",
    icon: "/img/dash.svg",
    activeIcon: "/img/dash-active.svg",
    link: "/dashboard",
  },
  {
    titleKey: "nav.accounts",
    icon: "/img/account.svg",
    activeIcon: "/img/account-active.svg",
    link: "/accounts",
  },
  {
    titleKey: "nav.vehicles",
    icon: "/img/vehicles.svg",
    activeIcon: "/img/vehicles-active.svg",
    link: "/vehicles",
  },
  {
    titleKey: "nav.trips",
    icon: "/img/trips.svg",
    activeIcon: "/img/trips-active.svg",
    link: "/trips",
  },
  {
    titleKey: "nav.employees",
    icon: "/img/employees.svg",
    activeIcon: "/img/employees-active.svg",
    link: "/employees",
  },
  {
    titleKey: "nav.finance",
    icon: "/img/finance.svg",
    activeIcon: "/img/finance-active.svg",
    link: "/finance",
  },
  {
    titleKey: "nav.advertising",
    icon: "/img/advertising.svg",
    activeIcon: "/img/advertising-active.svg",
    link: "/advertising",
  },
  {
    titleKey: "nav.targetedNotifications",
    icon: "/img/targeted-notifications.svg",
    activeIcon: "/img/targeted-notifications-active.svg",
    link: "/targeted-notifications",
  },
  {
    titleKey: "nav.rewards",
    icon: "/img/rewords.svg",
    activeIcon: "/img/rewords-active.svg",
    link: "/rewards",
  },
  {
    titleKey: "nav.insights",
    icon: "/img/insights.svg",
    activeIcon: "/img/insights-active.svg",
    link: "/insights",
  },
  {
    titleKey: "nav.incidents",
    icon: "/img/incidents.svg",
    activeIcon: "/img/incidents-active.svg",
    link: "/incidents",
  },
  {
    titleKey: "nav.auditLog",
    icon: "/img/logs.svg",
    activeIcon: "/img/logs-active.svg",
    link: "/logs",
  },
  {
    titleKey: "nav.supportCenter",
    icon: "/img/support.png",
    activeIcon: "/img/support-active.png",
    link: "/support",
  },
  {
    titleKey: "nav.disputesCenter",
    icon: "/img/disputes.svg",
    activeIcon: "/img/disputes-active.svg",
    link: "/disputes",
  },
  {
    titleKey: "nav.appVersions",
    icon: "/img/app-versions.svg",
    activeIcon: "/img/app-versions-active.svg",
    link: "/dashboard/app-versions",
  },
  {
    titleKey: "nav.configuration",
    icon: "/img/config.png",
    activeIcon: "/img/configActive.png",
    link: "/config",
  },
];

export const onDemandSidebarItems = [
  {
    titleKey: "nav.odOverview",
    icon: "/img/dash.svg",
    activeIcon: "/img/dash-active.svg",
    link: "/on-demand",
  },
  {
    titleKey: "nav.odRequests",
    icon: "/img/disputes.svg",
    activeIcon: "/img/disputes-active.svg",
    link: "/on-demand/requests",
  },
  {
    titleKey: "nav.odDrivers",
    icon: "/img/account.svg",
    activeIcon: "/img/account-active.svg",
    link: "/on-demand/drivers",
  },
  {
    titleKey: "nav.odScheduled",
    icon: "/img/trips.svg",
    activeIcon: "/img/trips-active.svg",
    link: "/on-demand/scheduled",
  },
  {
    titleKey: "nav.odReports",
    icon: "/img/insights.svg",
    activeIcon: "/img/insights-active.svg",
    link: "/on-demand/reports",
  },
  {
    titleKey: "nav.odPricing",
    icon: "/img/finance.svg",
    activeIcon: "/img/finance-active.svg",
    link: "/on-demand/finance",
  },
  {
    titleKey: "nav.odAuditLog",
    icon: "/img/logs.svg",
    activeIcon: "/img/logs-active.svg",
    link: "/on-demand/audit-log",
  },
  {
    titleKey: "nav.odConfiguration",
    icon: "/img/app-versions.svg",
    activeIcon: "/img/app-versions-active.svg",
    link: "/on-demand/settings",
  },
];

export const formatYAxis = (tick) => {
  return `${tick} M`;
};
export const activeUsersColors = [
  "rgba(13, 78, 121, 1)",
  "rgba(41, 128, 185, 1)",
];
export const tripsTodayColors = [
  "rgba(39, 174, 96, 1)",
  "rgba(25, 232, 112, 1)",
];
export const tripTypesColors = [
  "rgba(39, 174, 96, 1)",
  "rgba(41, 128, 185, 1)",
  "rgba(13, 78, 121, 1)",
];
export const commissonStyle = [
  "rgba(39, 174, 96, 1)",
  "rgba(41, 128, 185, 1)",
  "rgba(189, 61, 68, 1)",
];
export const tableContainerStyle = {
  borderRadius: "24px",
  overflowX: "auto",
  border: "none",
  boxShadow: "none",
  "&::-webkit-scrollbar": { height: 6 },
  "&::-webkit-scrollbar-thumb": { borderRadius: 4, background: "#ccc" },
};
export const tableRowStyle = {
  borderBottom: "4px solid rgba(227, 231, 234, 1)",
};
export const mapContainerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "12px",
};
